<template>
  <div class="MyRequestedElementsComponent  DataTables">
    
    <div :id="id">
      <LoaderComponent v-if="!isData"></LoaderComponent>
    </div>
    
    <br>
  </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

import * as Tools from '@/Tools/Tools';
import dt from 'datatables.net-bs4';


require("datatables.net-select-bs4");
require("datatables.net-keytable");
require("datatables.net-buttons-bs4");
require("@/components/shared/DataTables/jszip.min.js");
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

require("@/components/shared/DataTables/buttons.html5.min.js");
require("@/components/shared/DataTables/buttons.print.min.js");
require("@/components/shared/DataTables/buttons.colVis.min.js");

import 'datatables.net-select-bs4/css/select.bootstrap4.min.css'
import 'datatables.net-keytable-bs4/css/keyTable.bootstrap4.min.css'

import LoaderComponent from "@/components/shared/LoaderComponent"

import { mapGetters } from 'vuex'
export default {
  name: 'MyRequestedElementsComponent',
  props: {
    lang: Object
  },
  components: {
    LoaderComponent,
    

  },
  data() {
    return {
      //name: "DataTableFilteredOnApiProjComponent",
      name: "MyRequestedElementsComponent",
      id: "tableplace_" + this._uid,
      mainTable: "",
      columns: [],
      colsAssign: [],
      tasks: [],
      
      
      lengthMenu: 8,
      searchText: "",
    }
  },
  computed: {
    ...mapGetters({
      
      

    }),
    currentUser(){
      return this.$store.getters.currentUser;
    },
    isData() {

      return false
    },
    /*server(){

      return this.$store.getters.server;
    },*/
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    variant() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return "light";
      } else {
        return "dark";
      }

    }

  },
  created() {
    

  },
  watch: {
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getProperties();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
    

  },
  updated() {

  },
  mounted: function () {

    this.buildColumns();


  },
  methods: {
    
    buildColumns() {
      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",
          type: "text"
        },
        // {
        //   name: this.lang.table_header_Revision,
        //   alignInColumn: "left",
        //   type: "taxt"
        // },
        {
          name: this.lang.table_header_Type,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Date,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Level,
          alignInColumn: "left",
          type: "text"
        },

      ];

      this.colsAssign = [
        { "data": "col___revisionId" },
        { "data": "col___nameNumber" },
        //{ "data": "revision" },
        { "data": "col___source" },
        { "data": "col___creationDate" },
        { "data": "col___level" },
        

      ]

      


      this.buildTable();
      setInterval( this.buildTable, 30000);
    },


    buildTable() {


      //let lengthMenu = 20;



      // if (this.$store.getters.outerData != true) {

      //   this.$store.dispatch("deleteAllSelectedRows");
      //   this.$store.dispatch("setOuterData", false);
      // }

      var tableplace = document.getElementById("tableplace_" + this._uid);
      if (tableplace == null) {
        return;
      }
      while (tableplace.firstChild) {
        tableplace.removeChild(tableplace.firstChild);
      }

      var place = document.createElement("table");
      place.setAttribute("id", "place" + this._uid);
      place.setAttribute("class", "table table-striped table-bordered");
      place.setAttribute("style", "width:100%;");
      tableplace.appendChild(place)

      var tr1 = document.createElement("tr");
      tr1.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr1);
      place.appendChild(thead);

      // var tr2 = document.createElement("tr");
      // tr2.setAttribute("class", "cellFooter");
      // var tfoot = document.createElement("tfoot");
      // tfoot.appendChild(tr2);
      // place.appendChild(tfoot);



      var columnDefs = [];


      let _vue = this;

      var len = this.columns.length;

      let y = 0;

      for (let i = 0; i < len; i++) {

        let el = {
          targets: i,
          className: '_dt-body-' + _vue.columns[i].alignInColumn,
          render: function (data, type, row, meta) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 1) {
              let str = data.value.display;
              if (data.value.display.length > 40) {
                let substr = data.value.display.substr(0, 40);
                str = substr.trim() + "...";
              }
              return str;
            }
            
            if (meta.col == 2) {
              if (data.value.display == "library") {
                
                return "lib" + " (" + row.col___revisionId.libraryType + ")";
              }

            }
            if (meta.col == 3) {
              return Tools.longDateToShort(data.value.display);
            }

            

            if (meta.col == 4) {
              
              
              return data.value.display;
            }



            return data.value.display;



          }
        }



        columnDefs.push(el);




        var th1 = document.createElement("th");

        tr1.appendChild(th1);

        var br = document.createElement("br");
        var tx = document.createTextNode(this.columns[i].name);
        th1.appendChild(br);
        th1.appendChild(tx);

      }

      let vue = this;


      var option = {};


      option.keys = false;
      //json.data= datatable;
      option.myColumnFormats = this.columns;
      option.colReorder = false;
      option.lengthMenu = [[8]];
      option.order = [[3, "desc"]];
      option.select = true;
      option.columns = this.colsAssign;
      option.columnDefs = columnDefs;
      option.dom = '<fr<t>ip>';

      option.processing = true;
      option.serverSide = true;
      // option.search = {
      //   regex: true
      // }
      option.initComplete = function (settings, json) {


      }
      option.fnDrawCallback = function (oSettings) {

        
      }
      

      option.ajax = {
        url: /*this.server + */"/api/v3/dashboard/widgets/GetMyRequestedElements",

        crossDomain: true,
        type: 'POST',
        dataType: 'json',
        cors: true,
        contentType: 'application/json',
        secure: false,
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
        },
        error: function (xhr, ajaxOptions, thrownError) {
          // console.log(xhr)
          // console.log(xhr.status)
          // console.log(thrownError)
          if (xhr.responseJSON.message == "Authorization failure.") {

            vue.$store.dispatch("logout");
          }

        },
        data: function (json) {


          
          for (let i = 0, lei = json.columns.length; i < lei; i++) {
            json.columns[i].col = i;
          }

          //console.log(json)

          return JSON.stringify(json);
        },
        dataFilter: function (data) {
          
          
          
          y = 0;
          var json = JSON.parse(data);
       

          let newJson = {
            draw: json.data.draw,
            recordsFiltered: json.data.recordsFiltered,
            recordsTotal: json.data.recordsTotal,
            data: []
          }
          let rows = [];
          vue.lengthMenu = json.data.data.length;
          for (let i = 0, lei = json.data.data.length; i < lei; i++) {

            let row = {};
            let objId = {
              id: json.data.data[i].id,
              revisionId: json.data.data[i].revisionId,
              nameNumber: json.data.data[i].nameNumber,
              revision: json.data.data[i].revision,
              creationDate: json.data.data[i].creationDate,
              type: json.data.data[i].type,
              assembly: json.data.data[i].assembly,
              source: json.data.data[i].source,
              libraryType: json.data.data[i].libraryType,
              userId: json.data.data[i].userId,
              value: {
                display: json.data.data[i].revisionId,
                filter: json.data.data[i].revisionId,
                sort: json.data.data[i].revisionId
              }
            };

            let revisionId = "col___revisionId";
            row[revisionId] = objId;

            
            let objNameNumber = {
              id: json.data.data[i].id,
              revisionId: json.data.data[i].revisionId,
              nameNumber: json.data.data[i].nameNumber,
              revision: json.data.data[i].revision,
              creationDate: json.data.data[i].creationDate,
              type: json.data.data[i].type,
              assembly: json.data.data[i].assembly,
              source: json.data.data[i].source,
              libraryType: json.data.data[i].libraryType,
              userId: json.data.data[i].userId,
              value: {
                display: json.data.data[i].nameNumber,
                filter: json.data.data[i].nameNumber,
                sort: json.data.data[i].nameNumber
              }
            };

            let nameNumber = "col___nameNumber";
            row[nameNumber] = objNameNumber;

            let objSource = {
              id: json.data.data[i].id,
              revisionId: json.data.data[i].revisionId,
              nameNumber: json.data.data[i].nameNumber,
              revision: json.data.data[i].revision,
              creationDate: json.data.data[i].creationDate,
              type: json.data.data[i].type,
              assembly: json.data.data[i].assembly,
              source: json.data.data[i].source,
              libraryType: json.data.data[i].libraryType,
              userId: json.data.data[i].userId,
              value: {
                display: json.data.data[i].source,
                filter: json.data.data[i].source,
                sort: json.data.data[i].source
              }
            };

            let source = "col___source";
            row[source] = objSource;

            let objCreationDate = {
              id: json.data.data[i].id,
              revisionId: json.data.data[i].revisionId,
              nameNumber: json.data.data[i].nameNumber,
              revision: json.data.data[i].revision,
              creationDate: json.data.data[i].creationDate,
              type: json.data.data[i].type,
              assembly: json.data.data[i].assembly,
              source: json.data.data[i].source,
              libraryType: json.data.data[i].libraryType,
              userId: json.data.data[i].userId,
              value: {
                display: json.data.data[i].creationDate,
                filter: json.data.data[i].creationDate,
                sort: json.data.data[i].creationDate
              }
            };

            let creationDate = "col___creationDate";
            row[creationDate] = objCreationDate;

            let objLevel = {
              id: json.data.data[i].id,
              revisionId: json.data.data[i].revisionId,
              nameNumber: json.data.data[i].nameNumber,
              revision: json.data.data[i].revision,
              creationDate: json.data.data[i].creationDate,
              type: json.data.data[i].type,
              assembly: json.data.data[i].assembly,
              source: json.data.data[i].source,
              libraryType: json.data.data[i].libraryType,
              userId: json.data.data[i].userId,
              level: json.data.data[i].level,
              value: {
                display: json.data.data[i].level,
                filter: json.data.data[i].level,
                sort: json.data.data[i].level
              }
            };

            let level = "col___level";
            row[level] = objLevel;

            rows.push(row);
          }


          newJson.data = rows;

          // console.log(newJson)

          return JSON.stringify(newJson);
        },

      }



      if ($.fn.dataTable.isDataTable('#place' + this._uid)) {
        this.mainTable.destroy();

      }

      this.mainTable = $('#place' + this._uid).DataTable(option);

      this.mainTable.column(0).visible(false);

      let el = document.getElementsByClassName("dataTables_processing")[0]
     
      el.classList.add("processing-top");
      


      //search input change view
      var searchplace = document.getElementById("place" + this._uid + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:") {
          searchplace.removeChild(searchplace.firstChild);
          break;
        }

      }


      searchplace.firstChild.setAttribute("placeholder", "Enter search words")
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm myrequested");
      searchplace.firstChild.addEventListener("input", function (evt) {

        _vue.$store.dispatch("setFilteredData", evt.target.value);
        _vue.searchText = evt.target.value;
      })
      let lengthplace = document.getElementById("place" + this._uid + "_length");
      if (lengthplace != null) {
        if (lengthplace.firstChild.firstChild != null) {
          lengthplace.firstChild.firstChild.nextSibling.setAttribute("class", "form-control form-control-sm select-length");
        }
      }
      this.mainTable.search(vue.searchText).draw();

      var stepWait = 0;
      var waitInterval;
      $(".dataTables_filter .myrequested")
        .unbind()
        .bind('input', function (e) {
          var item = $(this);
          stepWait = 0;

          if (!waitInterval) {
            waitInterval = setInterval(function () {

              if (stepWait >= 3) {
                clearInterval(waitInterval);
                waitInterval = '';
                let searchString = $(item).val();
                _mainTable.search(searchString).draw();
                stepWait = 0;
              }
              stepWait++;
            }, 150);
          }

        });

      let _mainTable = this.mainTable;
      this.mainTable
        // .on('select', function (e, dt, type, indexes) {
          



        // })
        // .on('deselect', function (e, dt, type, indexes) {

         


          
        // });

      $('#place' + this._uid + ' tbody').on('dblclick', 'tr', function (e) {
        e.stopPropagation()
        let rowData = _mainTable.rows(this._DT_RowIndex).data();
        

        let obj = {
          revisionId: rowData[0].col___revisionId.revisionId,
          id: rowData[0].col___revisionId.id,
          revision: rowData[0].col___revisionId.revision,
          assembly: rowData[0].col___revisionId.assembly,
          type: rowData[0].col___revisionId.type,
          nameNumber: rowData[0].col___revisionId.nameNumber,
          libraryType: rowData[0].col___revisionId.libraryType,
          userId: rowData[0].col___revisionId.userId,
          source: rowData[0].col___revisionId.source,
        }
        _vue.goTo(obj);
      });



    },
    goTo(goalObj) {

      
      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/PartManager/PartDetails";
      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          partId: goalObj.id
        },
        col___revision: {
          revisionId: goalObj.revision

        },
        col___status: {
          assembly: goalObj.assembly

        }
      }

      
      if (goalObj.source == "library") {
        to = "/LibraryManager/LibraryDetails";

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: goalObj.type
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: goalObj.nameNumber
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: goalObj.libraryType
            }
          }
        }
      }
      if (goalObj.source == "project") {
        to = "/ProjectManager/ProjectDetails";

        let type = "pending";

        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            userId: goalObj.userId,
            value: {
              display: goalObj.revisionId
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: goalObj.revision
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: type
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: goalObj.nameNumber
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___projectType: {
            revisionId: goalObj.revisionId,
            projectId: goalObj.id,
            value: {
              display: ""
            }
          }
        }
      }
      
      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      let routingObject = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.revisionId,
        id: goalObj.id,
        sourceType: "main", //"details"
        sourceId: "",
        sourceRevisionId: "",
        end: false
      }
  
      this.$store.commit("FORWARDROUTINGDATA", routingObject)

      // const query = {
      //   from: this.$route.path,
      //   to: to,
      //   revisionId: goalObj.revisionId,
      //   id: goalObj.id
      // }

      this.$router.push({ path: to, query: routingObject })




    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.MyRequestedElementsComponent {
  table {
    font-size: 0.75rem;
    padding: 0px !important;

  }

  table th {
    padding: 2px !important;

  }

  table th select {
    width: 100% !important;

  }

  table td {
    padding: 0rem !important;

    padding-left: 0.2rem !important;
    padding-right: 0.2rem !important;
    white-space: nowrap;
  }

  table.dataTable thead th {
    position: relative;
    background-image: none !important;
  }

  .dataTables_processing {
    position: absolute;
    top: 0px;
    left: 70%;
    width: 100%;
    height: 20px;
    margin-left: -50%;
    margin-top: 50px;
    padding-top: 5px;
    text-align: center;
    font-size: 1em;

  }

  .processing-top {
    top: 0px;
    
  }

  .processing-top-plugin {
    //top: 120px;
  }

  .dataTables_filter {
    font-size: 10px;
    float: left;
    width: 210px;
  }

  .dataTables_length {
    margin-left: 20px;
    width: 200px;
    float: left;
  }

  .dataTables_length label {
    display: inline-flex;
  }

  .select-length {
    padding: 0.1rem;
    margin-left: 10px;
    margin-right: 10px;
  }

  .searcher {
    float: left;
  }

  .dt-buttons {

    font-size: 0.7rem;
    //margin-left: 210px;

  }

  .dataTables_filter .form-control-sm,
  .input-group-sm>.form-control {
    padding: 0.1rem 0.1rem;
    font-size: 0.7rem;
    line-height: 1;
    width: 200px;
  }

  .btn {
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 3px;
    padding-right: 3px;

    font-size: 0.7rem;

  }

  .btn-group {
    display: block;
    padding-top: 2px;
    width: 350px;
    float: left;
  }

  ._dt-body-left {
    text-align: left;
  }

  ._dt-body-right {
    text-align: right;
  }

  ._dt-body-center {
    text-align: center;
  }

  .image-category {
    max-width: 40px;
    //border: solid 3px #666;
    border-radius: 2px;
    margin-top: 3px;
    margin-bottom: 3px;

  }

  .badge {
    margin-right: 1px;

    margin-bottom: 2px;
  }

  .badges {
    margin-top: 3px;
    margin-bottom: 2px;
  }

  .image-svg {
    max-width: 40px;
    //border: solid 3px #666;
    border-radius: 2px;
    margin-top: 3px;
    margin-right: 3px;
    margin-bottom: 3px;
    background-color: white;
    padding: 2px;
  }
}</style>



// WEBPACK FOOTER //
// src/components/shared/MyRequestedElementsComponent.vue